export function MESSAGE(state, message) {
    state.message = message;
}
export default {
    MESSAGE,
};
